import { render, staticRenderFns } from "./LimitPlasticTextView.vue?vue&type=template&id=7b3bf10d&scoped=true&"
import script from "./LimitPlasticTextView.vue?vue&type=script&lang=js&"
export * from "./LimitPlasticTextView.vue?vue&type=script&lang=js&"
import style0 from "./LimitPlasticTextView.vue?vue&type=style&index=0&id=7b3bf10d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3bf10d",
  null
  
)

export default component.exports